import {
  BookOpen,
  FolderKanban,
  LayoutGrid,
  MessageSquare,
  type LucideIcon,
} from 'lucide-react';
import {
  ASK_PATH,
  DESK_PATH,
  LIBRARY_PATH,
  isAskPath,
  isDeskPath,
  isLibraryPath,
} from './appRoutes';

export type ShellTabId = 'ask' | 'library' | 'desk' | 'projects';

export interface ShellTab {
  id: ShellTabId;
  label: string;
  /** Compact label under the sidebar icon strip */
  shortLabel: string;
  to: string;
  icon: LucideIcon;
  match: (pathname: string) => boolean;
}

export const shellTabs: ShellTab[] = [
  {
    id: 'ask',
    label: 'Ask RCM',
    shortLabel: 'Ask',
    to: ASK_PATH,
    icon: MessageSquare,
    match: isAskPath,
  },
  {
    id: 'library',
    label: 'RCM Library',
    shortLabel: 'Library',
    to: LIBRARY_PATH,
    icon: BookOpen,
    match: isLibraryPath,
  },
  {
    id: 'desk',
    label: 'RCM Desk',
    shortLabel: 'Desk',
    to: DESK_PATH,
    icon: LayoutGrid,
    match: isDeskPath,
  },
  {
    id: 'projects',
    label: 'My Projects',
    shortLabel: 'Projects',
    to: '/projects',
    icon: FolderKanban,
    match: (pathname) => pathname.startsWith('/projects'),
  },
];

export function activeShellTab(pathname: string): ShellTabId | null {
  const tab = shellTabs.find((t) => t.match(pathname));
  return tab?.id ?? null;
}
